import React from 'react';
import css from './Sections.module.css';
import Icons from '../../../components/Icons/Icons';
import classNames from 'classnames';
import { categoryQueryParam } from '../../../util/categories';

// Existing icons you already have
import swimSuitIcon from './CategoryIcons/swimSuit.png';
import trainingSuitIcon from './CategoryIcons/trainingSuit.png';
import swimmingCapsIcon from './CategoryIcons/swimming-cap.png';
import gogglesIcon from './CategoryIcons/goggles.png';

// Reuse what you have for new categories
import trainingGearIcon from './CategoryIcons/kickboard.svg';
import techWearablesIcon from './CategoryIcons/techLogo.png';
import bagsBackpacksIcon from './CategoryIcons/bagLogo.png';
import clothingIcon from './CategoryIcons/clothing.png';
import accessoriesIcon from './CategoryIcons/accessoriesIcon.png';
import otherIcon from './CategoryIcons/otherLogo.svg';

function SectionShopByCategory({ useHistoryPush, isMobileLayout, intl }) {
  const productCategories = [
    {
      key: 'technicalSuits',
      label: intl.formatMessage({ id: 'SectionShopByCategory.category.technicalSuits' }),
      icon: swimSuitIcon,
      query: categoryQueryParam('technicalSuits'),
    },
    {
      key: 'trainingSuits',
      label: intl.formatMessage({ id: 'SectionShopByCategory.category.trainingSuits' }),
      icon: trainingSuitIcon,
      query: categoryQueryParam('trainingSuits'),
    },
    {
      key: 'swimCaps',
      label: intl.formatMessage({ id: 'SectionShopByCategory.category.swimCaps' }),
      icon: swimmingCapsIcon,
      query: categoryQueryParam('swimCaps'),
    },
    {
      key: 'goggles',
      label: intl.formatMessage({ id: 'SectionShopByCategory.category.goggles' }),
      icon: gogglesIcon,
      query: categoryQueryParam('goggles'),
    },
    {
      key: 'trainingGear',
      label: intl.formatMessage({ id: 'SectionShopByCategory.category.trainingGear' }),
      icon: trainingGearIcon, 
      query: categoryQueryParam('trainingGear'),
    },
    {
      key: 'techAndWearables',
      label: intl.formatMessage({ id: 'SectionShopByCategory.category.techAndWearables' }),
      icon: techWearablesIcon, 
      query: categoryQueryParam('techAndWearables'),
    },

    {
      key: 'bagsAndBackpacks',
      label: intl.formatMessage({ id: 'SectionShopByCategory.category.bagsAndBackpacks' }),
      icon: bagsBackpacksIcon,
      query: categoryQueryParam('bagsAndBackpacks'),
    },
    {
      key: 'clothing',
      label: intl.formatMessage({ id: 'SectionShopByCategory.category.clothing' }),
      icon: clothingIcon,
      query: categoryQueryParam('clothing'),
    },
    {
      key: 'accessories',
      label: intl.formatMessage({ id: 'SectionShopByCategory.category.accessories' }),
      icon: accessoriesIcon,
      query: categoryQueryParam('accessories'),
    },
    {
      key: 'other',
      label: intl.formatMessage({ id: 'SectionShopByCategory.category.other' }),
      icon: otherIcon,
      query: categoryQueryParam('other'),
    },
  ];

  // Keep existing behavior: show only first 3 on mobile
  const mobileCategories = productCategories;

  return (
    <div className={css.sectionShopByCategory}>
      <div className={css.fixedWidthContainer}>
        <div className={css.categories}>
          {mobileCategories.map(category => (
            <div
              key={category.key}
              className={css.category}
              role="button"
              onClick={() => useHistoryPush('SearchPage', {}, category.query)}
            >
              <div className={css.categoryImg}>
                <img src={category.icon} alt={category.label} />
              </div>
              <p>{category.label}</p>
            </div>
          ))}

          {/* All Categories */}
          <div
            className={css.category}
            role="button"
            onClick={() => useHistoryPush('SearchPage', {}, {})}
          >
            <div className={classNames(css.categoryImg, css.allCategories)}>
              <Icons name="gridIcon" />
            </div>
            <p>{intl.formatMessage({ id: 'SectionShopByCategory.allCategories' })}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionShopByCategory;
